/**
 * Description: member接口
 * Author: sunc
 * Date: 2019-06-28
 * Time: 14:30
 */

export const mailApiMap = {
  getMail: 'mail/ems/v1/ems-trackmail',
  // 获取办件邮寄信息
  getTaskMail: '/mail/tskmail/v1/mail',
  //得到邮件邮寄收件、寄件费用
  mailInfo:'/mail/ems/v1/ems-orderfilter'

}
